import { cssBreakpoints } from '../../common/breakpoints';
const cssBreakpointMatchMedium = matchMedia(`(min-width: ${cssBreakpoints.md})`);
const cssBreakpointMatchLarge = matchMedia(`(max-width: ${cssBreakpoints.xl})`);

function mapMenuSpacer({ document }) {
  const menu = document.querySelector('#menu-sticky-bottom');
  if (!menu) {
    return;
  }
  const mapElement = document.querySelector('#map');
  const rect = menu.getBoundingClientRect();
  if (cssBreakpointMatchMedium.matches && cssBreakpointMatchLarge.matches) {
    mapElement.style.bottom = `${rect.height}px`;
  } else {
    mapElement.style.bottom = 0;
  }
}

function handleMapMenuSpacer(window) {
  window.addEventListener('resize', () => mapMenuSpacer(window));
  mapMenuSpacer(window);
}

export default handleMapMenuSpacer;
